<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="800"
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar flat dark color="primary" class="hidden-sm-and-up">
        <v-btn icon @click.native="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Create crewman</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items class="mr-0">
          <v-btn dark text @click.native="save">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-title class="headline hidden-xs-only">Create new crewman</v-card-title>
      <v-card-text>
        <div>
          <template v-if="isLoading">
            <div class="content-spinner" style="min-height: 200px">
              <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
            </div>
          </template>
          <template v-else>
            <RoleInVesselForm
              ref="form"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :initial-values="item"
              :errors="violations"
            />
          </template>

          <v-dialog v-model="errorDialog" max-width="290">
            <v-card>
              <v-card-text>There was an error submitting the form</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="green darken-1" text @click.native="errorDialog = false">Cancel</v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click.native="
                    $refs.form.onSubmit(item)
                    errorDialog = false
                  "
                  >Try again</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-card-text>

      <v-card-actions class="hidden-xs-only">
        <div class="flex-grow-1"></div>
        <v-btn color="green darken-1" text @click.native="close">Cancel</v-btn>
        <v-btn color="green darken-1" text @click.native="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import RoleInVesselForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('roleinvessel/create')

export default {
  components: {
    RoleInVesselForm
  },

  props: {
    show: {
      type: Boolean,
      required: true
    },
    vessel: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      item: {
        user: {
          emailVerified: false,
          enabled: true,
          realmRoles: ['ROLE_CUSTOMER'],
          requiredActions: ['VERIFY_EMAIL', 'UPDATE_PASSWORD']
        },
        vessel: this.vessel
      },
      errorDialog: false
    }
  },

  computed: {
    ...mapGetters(['error', 'isLoading', 'created', 'violations']),
    dialog: {
      // getter
      get: function() {
        return this.show
      },
      // setter
      set: function(show) {
        if (false === show) {
          this.close()
        }
      }
    }
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function(created) {
      if (!created) {
        return
      }

      this.close()
    },
    error: function(error) {
      if (!error) {
        return
      }

      this.errorDialog = true
    }
  },

  methods: {
    ...mapActions(['create']),

    close() {
      this.$parent.showCreateDialog = false
    },

    save() {
      this.$refs.form.onSubmit(this.item)
    },

    onSendForm() {
      this.create(this.item)
    },

    updateField(field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
